import { Button } from "@/components/ui/button";
import { Check, Circle } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { cn } from "@/lib/utils";
import { Exercise } from "../../types";
import { useState } from 'react';
interface ExerciseListProps {
  exercises: Exercise[];
  activeExerciseId: string;
  completedSets: {
    [key: string]: boolean[];
  };
  onExerciseSelect: (exerciseId: string) => void;
}
export const ExerciseList = ({
  exercises,
  activeExerciseId,
  completedSets,
  onExerciseSelect
}: ExerciseListProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const completedExercisesCount = exercises.filter(ex => completedSets[ex.id]?.every(Boolean)).length;
  return <div className="mt-6 mb-8 relative">
      <Accordion type="single" collapsible className="w-full" value={isOpen ? "exercises" : ""}>
        <AccordionItem value="exercises" className="border-none">
          <AccordionTrigger className="py-4 px-5 text-base text-foreground hover:text-foreground/80 bg-white/5 hover:bg-white/10 transition-all duration-300 rounded-2xl border border-white/10 group" onClick={() => setIsOpen(!isOpen)}>
            <span className="flex items-center gap-3">
              <span className="text-sm font-medium">Ejercicios de la rutina</span>
              <span className="text-xs text-muted-foreground bg-white/10 px-2 py-0.5 rounded-full">
                {completedExercisesCount}/{exercises.length}
              </span>
            </span>
            
          </AccordionTrigger>
          <AccordionContent className="w-72 sm:w-full rounded-2xl bg-black/60 backdrop-blur-xl border border-white/10 shadow-2xl" style={{
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
          bottom: "calc(100% + 8px)",
          zIndex: 10
        }}>
            <div className="max-h-[50vh] overflow-y-auto scrollbar-thin scrollbar-thumb-white/10 scrollbar-track-transparent">
              <div className="space-y-1 p-2">
                {exercises.map((ex, index) => {
                const isActive = ex.id === activeExerciseId;
                const isCompleted = completedSets[ex.id]?.every(Boolean);
                return <Button key={ex.id} variant="ghost" className={cn("w-full justify-start text-left py-4 px-4 rounded-xl transition-all duration-200 gap-3", isActive && "bg-primary/20 text-primary border border-primary/30", !isActive && isCompleted && "bg-green-500/10 text-green-400", !isActive && !isCompleted && "hover:bg-white/10 text-foreground")} onClick={() => {
                  onExerciseSelect(ex.id);
                  setIsOpen(false);
                }}>
                      {/* Status indicator */}
                      <div className={cn("w-6 h-6 rounded-full flex items-center justify-center text-xs font-medium shrink-0", isActive && "bg-primary text-primary-foreground", !isActive && isCompleted && "bg-green-500 text-white", !isActive && !isCompleted && "bg-white/10 text-muted-foreground")}>
                        {isCompleted ? <Check className="h-3.5 w-3.5" /> : index + 1}
                      </div>
                      <span className="truncate flex-1 text-sm">{ex.name}</span>
                      {isActive && <Circle className="h-2 w-2 fill-primary text-primary animate-pulse" />}
                    </Button>;
              })}
              </div>
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>;
};